<template>
  <div>
    <ejs-grid ref='grid' :dataSource="data" height='100%' :rowSelected='getChooseCount' :allowReordering='true' :allowResizing='true' :selectedRowIndex='selectedRowIndex' >
      <e-columns>
        <e-column field='cellid' :headerText='$t("Spectrum.ui_cell")' textAlign='Center' clipMode="EllipsisWithTooltip"></e-column>
        <e-column field='sectorid' :headerText='$t("Spectrum.ui_spectrumsectorid")' textAlign='Center' clipMode="EllipsisWithTooltip"></e-column>
        <e-column field='phycellid' :headerText='$t("Spectrum.ui_spectrumphycellid")' textAlign='Center' clipMode="EllipsisWithTooltip"></e-column>
        <e-column field='oper' :headerText='$t("Spectrum.ui_oper")' textAlign='Center' :template='operTemplate' clipMode="EllipsisWithTooltip"></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm.js';
import { GridPlugin } from '@syncfusion/ej2-vue-grids';
import OpertionHref from './CreateSpectrumTaskButton';

Vue.use(GridPlugin);
export default {
  name: 'BSCellTable',
  props: [
    'ne'
  ],
  data() {
    return {
      selectedRowIndex: 0,
      data: {},
      defaultRowCellid: 0,
      firstTableData: false,
      info: {
        neId: '',
        netype: 'enodeb',
        neversion: ''
        // createSpectrumTaskCellId: ''
      },
      operTemplate() {
        return {
          /* template: Vue.component('operOption', {
            template: '<div><a  ref="alt" @click="test">添加</a></div>',
            methods:{
              test(){
                const This = this;
                console.log(1111);
              }
            }
          }) */
          template: OpertionHref
        };
      }
    };
  },
  methods: {
    getChooseCount(args) {
      const record = args.data;
      if (this.firstTableData) {
        this.$parent.$parent.$children[1].cellid = this.defaultRowCellid;
        this.firstTableData = false;
      } else {
        this.$parent.$parent.$children[1].cellid = record.cellid;
      }
      this.$parent.$parent.$children[1].neId = this.info.neId;
      this.$parent.$parent.$children[1].getGridData();
      // const selectedRecords = this.$refs.grid.getSelectedRecords();
      // console(selectedRecords);
      // this.info.createSpectrumTaskCellId = record.cellid;
    },
    getGridData() {
      const $this = this;
      $this.info.neId = this.$parent.ne.id;
      // $this.info.netype = ne.data.neType;
      // $this.info.neversion = ne.data.neVersion;
      const cellId = '';
      this.$axios.get(`/lte/ems/spectrum/selectMoRecords.html?neId=${$this.info.neId}&cellId=${cellId}`).then((response) => {
        const res = response.data;
        if (res.errorCode === 'SUCCESS') {
          $this.data = res.resultVal;
          if (res.resultVal.length === 0) {
            this.$parent.$parent.$children[1].neId = this.info.neId;
            this.$parent.$parent.$children[1].getGridData();
          } else {
            $this.defaultRowCellid = res.resultVal[0].cellid;
            $this.firstTableData = true;
            $this.$refs.grid.selectRow(0);
          }
        } else {
          alert(this.$t(res.errorCode));
        }
      });
    },
    getParams() {
      const $this = this;
      let qryParams = null;
      qryParams = {
        neId: $this.info.neId,
        cellId: ''
      };
      return qryParams;
    }
  }
};
</script>

<style>

</style>
